import template from './swag-cms-extensions-block-rule-select.html.twig';

export default {
    template,

    methods: {
        dismissSelection() {
            this.$emit('dismiss-rule');
        },
    },
}
